"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Allowed parameters for a NodeShape
 */
exports.default = {
    targetNode: true,
    targetObjectsOf: true,
    targetSubjectsOf: true,
    deactivated: true,
    severity: true,
    message: true,
    class: true,
    datatype: true,
    nodeKind: true,
    minExclusive: true,
    minInclusive: true,
    maxExclusive: true,
    maxInclusive: true,
    minLength: true,
    maxLength: true,
    pattern: true,
    flags: true,
    languageIn: true,
    equals: true,
    disjoint: true,
    closed: true,
    ignoredProperties: true,
    hasValue: true,
    in: true,
};
